<script>
export default {
  name: "SliceParagraphWithVisual",
  props: ["item", "slice"],
  mounted() {
    // Only load once
    if (!document.getElementById("classy-sdk")) {
      const script = document.createElement("script")
      script.id = "classy-sdk"
      script.src = "https://giving.classy.org/embedded/api/sdk/js/84581"
      script.async = true
      document.body.appendChild(script)

      script.onload = () => {
        console.log("Classy SDK loaded")
        // if the SDK needs initialization, do it here
      }
    }
  }
}
</script>

<template>
  <div style="position:relative;overflow:hidden;padding:3rem;background:linear-gradient(90deg,#f1f7f8 0%,#e9f2f3 100%);font-family:inherit;mask-image:url('https://hungerfreeamerica.org/img/SwooshLong.c7512c72.png');-webkit-mask-image:url('https://hungerfreeamerica.org/img/SwooshLong.c7512c72.png');mask-size:100% 100%;-webkit-mask-size:100% 100%;"><div style="position:relative;z-index:1;display:grid;grid-template-columns:1fr auto;grid-template-areas:'content actions';gap:2rem;align-items:center;"><div style="grid-area:content;"><h2 style="margin:0 0 1rem;font-size:2rem;line-height:1.2;">Support Hunger Free America</h2><p style="margin:0;">Help us fight hunger and build a food-secure America.</p></div><div style="grid-area:actions;"><a href="https://giving.gofundme.com/campaign/714226/donate" target="_blank" rel="noopener noreferrer" style="display:inline-flex;align-items:center;width:auto;cursor:pointer;border-radius:1rem;overflow:hidden;border:0;padding:0;background:#007c91;color:#fff;text-decoration:none;font-weight:600;line-height:1;"><span style="padding:12px 16px;">Donate</span><span style="padding:12px 16px;">→</span></a></div></div></div>
</template>

<style scoped lang="scss">
  .widget{
    display: flex;
    justify-content: center; /* horizontal center */
    align-items: center;     /* vertical center (if you want it) */
    width: 100%;
  }
</style>
